import React, { useState } from 'react';
import { Container, Tab, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import Statistics from '../components/admin/Statistics';
import TripManagement from '../components/admin/TripManagement';
import ApplicationManagement from '../components/admin/ApplicationManagement';
import UserManagement from '../components/admin/UserManagement';
import ArticleManagement from '../components/admin/ArticleManagement';
import SubscriberManagement from '../components/admin/SubscriberManagement';
import AdminTabs from '../components/admin/AdminTabs';
import './AdminDashboardPage.css';

const AdminDashboardPage = () => {
  const { isAdmin } = useAuth();
  const [key, setKey] = useState('statistics');

  if (!isAdmin()) {
    return (
      <Container>
        <Alert variant="danger">
          You don't have permission to access the admin dashboard.
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="admin-dashboard">
      <h1 className="admin-header">Admin Dashboard</h1>
      
      <AdminTabs activeKey={key} onSelect={(k) => setKey(k)}>
        <Tab eventKey="statistics" title="📊 Statistics">
          <Statistics />
        </Tab>
        
        <Tab eventKey="trips" title="Trip Management">
          <TripManagement />
        </Tab>
        
        <Tab eventKey="applications" title="Applications">
          <ApplicationManagement />
        </Tab>
        
        <Tab eventKey="users" title="User Management">
          <UserManagement />
        </Tab>
        
        <Tab eventKey="articles" title="📝 Articles">
          <ArticleManagement />
        </Tab>
        
        <Tab eventKey="subscribers" title="📧 Subscribers">
          <SubscriberManagement />
        </Tab>
      </AdminTabs>
    </Container>
  );
};

export default AdminDashboardPage;